/**
 * A person's name as it should be printed, whatever case it was typed in:
 * every word lower case but its first letter, which is upper case — and so is
 * the one after an apostrophe or a hyphen ("D'Urso", "Anna-Maria").
 * "IVAN CERNUTO" and "ivan cernuto" are both "Ivan Cernuto".
 *
 * By rule, not by name: "de Luca" becomes "De Luca" too.
 */
export function properName(name: string): string {
  return name
    .toLocaleLowerCase('it')
    .replace(/(^|[\s'’-])(\p{L})/gu, (_, before: string, letter: string) => before + letter.toLocaleUpperCase('it'));
}
